import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {UntypedFormGroup, UntypedFormBuilder} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {UserMappingService} from '../services/usermapping.service';

@Component({
  selector: 'app-delete-user-dialog',
  templateUrl: './delete-user-dialog.component.html',
  styleUrls: ['./delete-user-dialog.component.css']
})
export class DeleteUserDialogComponent {

  form: UntypedFormGroup;


  constructor(public dialogRef: MatDialogRef<DeleteUserDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              fb: UntypedFormBuilder,
              private readonly toastr: ToastrService,
              private readonly usermappingService: UserMappingService) {

    this.form = fb.group({});
  }

  submit() {
    if (this.form.valid) {
      this.usermappingService.deleteUser(this.data.userMapping.id).then(res => {
        this.toastr.success('Användaren har tagits bort', 'Användare');
      }).catch(res => {
        this.toastr.error('Fel! Något gick fel när användaren togs bort', 'Användare');
      });
      ;
      this.dialogRef.close();
    }
  }

}
